import React, { ComponentState, useEffect, useState } from "react";
import SignatureKendoRct from "../../../../../components/signature-kendo";
import { AppInput } from "../../../../../components/Input";
import { ErrorConsts } from "../../../../../utils/ErrorCons";
import { AppButtons } from "../../../../../components/button";
import { ClientUploadSignModel } from "../../../../../dataModel/clientModels";
import { useDispatch, useSelector } from "react-redux";
import { updateClientSigns } from "../../../../../redux/actions";



export interface SignatureProps {
  onClose(): void,
  title: string,
  clientID: number, isParent: boolean
}

export const AddSignature = (props: SignatureProps) => {


  const [sigValue, setSigValue] = React.useState<any>();
  const [buttonPressed, setButtonPressed] = useState(false)
  const [pin, setPin] = useState<string>()
  const [Cpin, setCPin] = useState<string>()
  const [fName, setFname] = useState<string>('')
  const [lName, setLname] = useState<string>('')
  
  const dispatch = useDispatch()

  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { loadingState } = state['LoaderReducer'];
  const {genericSuccessResp} = state['ClientReducer'];
  const handleButtonPressedParent = () => {
    setButtonPressed(true)
    var file = sigValue?.split(",")[1];
    if (!file) {
      return
    }
    if (pin && pin.length > 3 && Cpin && Cpin.length > 3
       && fName.length > 0 && lName.length > 0) {
      const signRequest: ClientUploadSignModel = {
        signBytes: file,
        clientId: props.clientID,
        pinNumber: pin,
        isParentSig: props.isParent,
        parentLastName: fName,
        parentFirstName: lName,
      }
     
      dispatch(updateClientSigns(signRequest))
    }
  }




  const handleButtonPressed = () => {
   
    setButtonPressed(true)
    var file = sigValue?.split(",")[1];
    if (!file) {
      return
    }
    
    if (pin && pin.length > 3 && Cpin && Cpin.length > 3) {
      const signRequest: ClientUploadSignModel = {
        signBytes: file,
        clientId: props.clientID,
        pinNumber: pin,
        isParentSig: props.isParent,
      }
     
      dispatch(updateClientSigns(signRequest))
     
    }
  }


  const handleChangeSign = (e: any) => {
    setSigValue(e.value);
  }

  const handleClose = () => {
    props.onClose()
  }

  return (
    <>
      <div className="modal-wrapper">
        <div className="modal-Div my-3">
          <button className="close-btn" onClick={handleClose}>
            <i className="fa-regular fa-circle-xmark" ></i>
          </button>
          <h3 className="mb-3 fw-600">
            {'Draw Signature'}
            {/* {  props.title} */}
          </h3>
          <form>
            <SignatureKendoRct
              value={sigValue}

              onSigChange={handleChangeSign}
            />
            {(props.isParent) &&
              <div className="row">
                <div className="col-md-6">
                  <AppInput labelText="First Name"
                    placeHolder=""
                    showError={buttonPressed && (!fName || fName.length < 1)}
                    errorMessage={ErrorConsts.FIRST_NAME}
                    onChange={setFname}></AppInput>
                </div>
                <div className="col-md-6">
                  <AppInput labelText="Last Name"
                    placeHolder=""
                    showError={buttonPressed && (!lName || lName.length < 4)}
                    errorMessage={ErrorConsts.LAST_NAME}
                    onChange={setLname}></AppInput>

                </div>
              </div>
            }
            <div className="row ">
              <div className="col-md-6">
                <AppInput labelText="PIN"
                  placeHolder=""
                  maxLength={4}
                  inputType="password"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  showError={buttonPressed && (!pin || pin.length < 4)}
                  errorMessage={ErrorConsts.PIN}
                  onChange={setPin}></AppInput>
              </div>
              <div className="col-md-6">
                <AppInput labelText="Confirm PIN"
                  placeHolder=" "
                  inputType="password"
                  maxLength={4}
                  showError={buttonPressed && (!Cpin || Cpin.length < 1 || Cpin !== pin)}
                  errorMessage={Cpin !== pin ? ErrorConsts.PIN_MISMATCH : ErrorConsts.PIN}
                  onChange={setCPin}></AppInput>
                <div className="d-flex gap-2 align-items-center">
                </div>
              </div>
              <div className="col-md-12 d-flex gap-2 mt-3">
                <AppButtons buttonText="Submit" className="btn-common  btn-green" onclick={props.isParent ? handleButtonPressedParent : handleButtonPressed} loadingState={loadingState}></AppButtons>
                <AppButtons className="btn-common white-btn  text-center" buttonText="Cancel" onclick={handleClose} ></AppButtons>

              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}